import { createApi } from '@/api/modules/utils'

const baseUrl = '/knowledge/file/detail'
const api = createApi(baseUrl)

// 用户相关API
export const knowledgeFileDetailApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'post'),
  tags: api('tags', 'get'),
  tag: api('tag', 'post'),
  search: api('search', 'get'),
  select: api('select', 'get'),
}